import FormSection from "../components/FormSection";
import Conditions from "../components/Conditions";
import Button from "../components/Button";
import { useRef, useState } from "react";
import { FormData } from "../data/models";
import { sendEmail } from "../functions/services/sendEmail";
import SyncLoader from "react-spinners/SyncLoader";
import {
  fields1,
  conditionFields2,
  errorOrder,
} from "../data/models/FormFields";
import { isValidInput } from "../functions/utils";
import { useIframeAutoHeight } from "../functions/useIframeAutoHeight";

const NewsletterPage = () => {
  useIframeAutoHeight();
  const [loading, setLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormData>({
    general: {},
    conditions: [],
  });
  const [errors, setErrors] = useState<string[]>([]);
  const inputRefs = useRef<{ [key: string]: HTMLInputElement | null }>({}); // used for error scrolling

  const handleFormChange = (section: string, values: any) => {
    setFormData((prev) => ({
      ...prev,
      [section]: values,
    }));
  };

  const handleSubmit = async () => {
    const requiredFields = [...fields1];
    const allConditionFields = [...conditionFields2];

    // Find not filled out required fields
    const missingFields = requiredFields.filter(
      (field) => field.required && !formData.general[field.name]
    );

    allConditionFields.forEach((field) => {
      if (field.required && !formData.conditions.includes(field.id)) {
        const missingField = {
          name: field.id,
          placeholder: "",
          required: true,
        };
        requiredFields.push(missingField);
        missingFields.push(missingField);
      }
    });

    let validationErrors: string[] = [];
    validationErrors = missingFields.map((field) => field.name); // for error scrolling

    if (
      missingFields.length > 0 ||
      !isValidInput(formData.general["Email adresa"], "email")
    ) {
      setErrors(missingFields.map((field) => field.name));

      if (!isValidInput(formData.general["Email adresa"], "email")) {
        validationErrors.push("Email adresa");
      }

      validationErrors = sortValidationErrors(validationErrors);
      setErrors(validationErrors);

      // If there are errors, scroll to the first error
      if (validationErrors.length > 0) {
        const firstErrorField = validationErrors[0];
        const errorElement = inputRefs.current[firstErrorField];

        if (errorElement) {
          errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
          errorElement.focus();
        }
      }

      return;
    }

    setLoading(true);

    try {
      await sendEmail({ formData, mode: "newsletter" });
      setFormData({
        general: {},
        conditions: [],
      });

      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const sortValidationErrors = (errors: string[]) => {
    return errors.sort((a, b) => errorOrder.indexOf(a) - errorOrder.indexOf(b));
  };

  return (
    <div className="flex flex-col ">
      <div className="flex flex-col gap-6 px-6 pb-6 pt-10 self-center md:max-w-[570px] w-full">
        {/* Header */}
        <h1 className="text-lg font-bold sm:text-xl">
          PRIJAVITE SE NA NAŠ NEWSLETTER
        </h1>

        <hr className="w-full border-t-1 border-extra-light" />

        {/* Body */}
        <div className="flex flex-col gap-6 ">
          <FormSection
            title="Općenito"
            subtitle="Unesite podatke za prijavu na naš newsletter."
            fields={fields1}
            columns={1}
            data={formData.general}
            onChange={(values) => handleFormChange("general", values)}
            setErrors={setErrors}
            errors={errors}
            inputRefs={inputRefs}
          ></FormSection>
          <hr className="w-full border-t-1 border-extra-light" />

          {/*Uvjeti */}
          <div className="flex flex-col gap-6">
            <Conditions
              title="PRIVOLA"
              subtitle="Brinemo o našim klijentima i našim odnosima. Primajte personalizirane ponude, promocije, informacije o događajima i ostali sadržaj koji vas zanima od naših brendova."
              fields={conditionFields2}
              selected={formData.conditions}
              onChange={(updatedConditions) =>
                handleFormChange("conditions", updatedConditions)
              }
              setErrors={setErrors}
              errors={errors}
              inputRefs={inputRefs}
            />

            <hr className="w-full border-t-1 border-extra-light" />
            <Button
              text={loading ? "Slanje prijave" : "Prijavite se"}
              variant={"primary"}
              size={"base"}
              action={handleSubmit}
              icon={
                <SyncLoader
                  color={"white"}
                  loading={loading}
                  size={7}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              }
            ></Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterPage;
